import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "page-home-m" }
const _hoisted_2 = { class: "layout-guide" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "label" }

import { onBeforeMount } from "vue";
import banner from "@/components-m/Banner/index.vue";

interface guide {
  link: string | any;
  label: string;
  bg: string;
  // keyword: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const guideList: Array<guide> = [
  {
    link: "races",
    label: "职业攻略",
    bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/320510_m_01.png",
  },
  {
    link: "./article?ArticleID=345355",
    label: "历史版本",
    bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/320510_m_02.png",
  },
  {
    // link: "./#/article?ArticleID=346281",
    link: "/search",
    label: "文章搜索",
    bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/320510_m_03.png",
  },
  {
    link: {
      name: "Catalog",
      params: { id: "all" },
    },
    label: "全部文章",
    bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/320510_m_04.png",
  },
];
onBeforeMount(() => {
  // console.log(this);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(guideList, (item, index) => {
        return _createVNode(_component_router_link, {
          key: index,
          to: item.link,
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("div", {
              class: "guide",
              style: _normalizeStyle({ backgroundImage: `url(${guideList[index].bg})` }),
              onClick: navigate
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1)
            ], 12, _hoisted_3)
          ]),
          _: 2
        }, 1032, ["to"])
      }), 64))
    ]),
    _createElementVNode("div", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(banner), {
        title: "次元站公告",
        icon: "notice"
      }))
    ])
  ]))
}
}

})